import { RpcSettings, RpcSettingsResult } from './rpc-settings-model';

/**
 * Rpc setting request sever side handler interface.
 */
export interface RpcSettingsHandler {
    handler(data: RpcSettings): Promise<RpcSettingsResult>;
}
